import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "../../styles.module.css";

import BandejaEventos from "./bandeja-eventos";
import IngresarEvento from "./ingresar-eventos";

const Bitacora = (props) => {
  const rutcia = props?.rutcia? props?.rutcia : "8600399880";
  const idCaso =props?.idCaso ? props.idCaso : "6";
  const user =props?.user ? props.user : 22222220;
  
  const [key, setKey] = useState("home");

  const options={
      rutcia,
      idCaso,
      user
  }

  return (
    <Container>
      <Card className="mt-2">
        <Card.Header as="h5">Gestión Eventos Bitácora ID Caso {idCaso}</Card.Header>
        <Card.Body>
          <Tabs
            defaultActiveKey="0"
            id="uncontrolled-tab-example"
            className="mb-3"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab id="0" eventKey="home" title="Ver Eventos">
              <BandejaEventos {...options} />
            </Tab>
            <Tab id="1" eventKey="profile" title="Ingreso Evento Manual">
              <IngresarEvento {...options} />
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Bitacora;
